import { siteOrigin } from "../utils/siteOrigin";

const SITE_NAME = "Beaver Delivery";

function homeUrl(): string {
  const origin = siteOrigin();
  const base = process.env.REACT_APP_DIR ?? "";
  if (!base) {
    return `${origin}/`;
  }
  const path = base.endsWith("/") ? base : `${base}/`;
  return new URL(path.startsWith("/") ? path : `/${path}`, `${origin}/`).href;
}

/** トップページ専用の JSON-LD（ニュース等ではマウントしない） */
export function buildHomePageStructuredData() {
  const origin = siteOrigin();
  const url = homeUrl();
  const orgId = `${origin}/#organization`;
  const websiteId = new URL("#website", url).href;
  const webpageId = new URL("#webpage", url).href;
  const serviceId = new URL("#service", url).href;
  const faqId = new URL("#faq", url).href;

  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": orgId,
        name: SITE_NAME,
        url,
        logo: {
          "@type": "ImageObject",
          url: new URL("/favicon.png", url).href,
        },
      },
      {
        "@type": "WebSite",
        "@id": websiteId,
        url,
        name: SITE_NAME,
        description:
          "訪日観光客向けの海外配送サービス。伝票・インボイス作成、梱包、海外顧客対応を一括で支援します。",
        inLanguage: "ja-JP",
        publisher: { "@id": orgId },
      },
      {
        "@type": "WebPage",
        "@id": webpageId,
        url,
        name: "インバウンド対策のための海外配送サービスBeaver Delivery",
        description:
          "簡単な手続きで訪日観光客が購入した商品を国外の自宅まで配送できるサービスです。煩雑な海外配送向けの伝票作成・梱包はもちろん、海外のお客様対応もお任せください！万が一に備えた安心の保険対応も可能です。",
        isPartOf: { "@id": websiteId },
        about: { "@id": serviceId },
        primaryImageOfPage: {
          "@type": "ImageObject",
          url: new URL("/usage_image.webp", url).href,
        },
        inLanguage: "ja-JP",
      },
      {
        "@type": "Service",
        "@id": serviceId,
        name: "訪日観光客向け海外配送サービス（Beaver Delivery）",
        serviceType: "インバウンド向け越境配送・海外発送代行",
        description:
          "訪日観光客が日本で購入した商品を国外の自宅へ届けるための配送サービス。配送状・インボイス作成、梱包、海外からの問い合わせ対応を支援します。",
        provider: { "@id": orgId },
        areaServed: {
          "@type": "Country",
          name: "日本",
        },
        audience: {
          "@type": "BusinessAudience",
          audienceType: "免税店・酒販店・インバウンド事業者",
        },
      },
      {
        "@type": "FAQPage",
        "@id": faqId,
        mainEntity: [
          {
            "@type": "Question",
            name: "配送状やインボイス作成など煩雑な手続きが不安",
            acceptedAnswer: {
              "@type": "Answer",
              text: "お客様が自分のスマートフォンから直接配送先の住所を登録し、提携している配送センターで、配送状とインボイスを作成します。",
            },
          },
          {
            "@type": "Question",
            name: "割れたり、壊れたりしないか不安",
            acceptedAnswer: {
              "@type": "Answer",
              text: "お酒はエアパッキンに1本ずつ入れて海外配送用に丁寧に梱包します。お酒以外の商品は、必要に応じて段ボールの外側を緩衝材で補強します。",
            },
          },
          {
            "@type": "Question",
            name: "購入後、お客様からの問い合わせに多言語で答えられない",
            acceptedAnswer: {
              "@type": "Answer",
              text: "配送センターが窓口になります。",
            },
          },
        ],
      },
    ],
  };
}
